<template>
  <div class="home-content">
    <section class="hero">
      <div class="hero-body" style="padding:40px !important; ">
        <div class="container has-text-centered">
          <h2 class="title">{{ title }}</h2>
        </div>
      </div>
    </section>
    <div class="container b-portlet">
      <div class="b-portlet-body">
        <slot></slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'HomeContainer',
  props: {
    title: {
      type: String,
      default: ''
    }
  }
}
</script>
<style>
.home-content .hero {
  background: #83d7e7;
}

.home-content .hero-body {
  padding: 70px !important;
}

.home-content .tab-item {
  padding-top: 20px;
}
</style>
